(function () {
  'use strict';

  var buttonSelector = '.dd-pdp-recommendations .dd-collection-card__wishlist.swym-button';
  var scheduled = false;

  function hasPendingButtons() {
    return document.querySelector(buttonSelector + ':not(.swym-loaded)') !== null;
  }

  function reinitialize(swat) {
    swat = swat || window._swat;
    if (!swat || !hasPendingButtons()) return;

    if (typeof swat.initializeActionButtons === 'function') {
      swat.initializeActionButtons('.dd-pdp-recommendations');
      return;
    }

    if (typeof swat.initializeActionButtonsOnProductGrid === 'function') {
      swat.initializeActionButtonsOnProductGrid(buttonSelector);
    }
  }

  function schedule(swat) {
    if (scheduled) return;

    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      reinitialize(swat);
    });
  }

  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(function (swat) {
    schedule(swat);
  });

  document.addEventListener('swymAdvancedCollectionsInitialized', function () {
    schedule(window._swat);
  });

  var observer = new MutationObserver(function (mutations) {
    var recommendationChanged = mutations.some(function (mutation) {
      return Array.from(mutation.addedNodes).some(function (node) {
        return node.nodeType === 1 && (
          (node.matches && node.matches('.dd-pdp-recommendations, .dd-pdp-recommendations *')) ||
          (node.querySelector && node.querySelector(buttonSelector))
        );
      });
    });

    if (recommendationChanged) schedule(window._swat);
  });

  observer.observe(document.body, { childList: true, subtree: true });
  window.addEventListener('load', function () { schedule(window._swat); }, { once: true });
  schedule(window._swat);
})();
